import React, { Component } from 'react';

class MapMarker extends Component {
  render() {
    return (
      <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <title>MapMarker</title>
        <g id="icon-/-pin" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <rect id="Rectangle" fill="#FFFFFF" opacity="0" x="0" y="0" width="24" height="24"/>
          <path d="M12.5502423,0 C17.1765575,0 21,3.81536232 21,8.53591183 C21,13.4564251 15.6696221,20.4849177 12.5502423,24 C9.43233637,20.4849177 4,13.4564251 4,8.53591183 C4,3.81669987 7.82176774,0 12.5502423,0 Z M12.5502423,4.31828125 C14.5625488,4.31828125 16.2711904,6.02549705 16.2711904,8.03299291 C16.2711904,10.1412063 14.5611085,11.8483552 12.5502423,11.8483552 C10.4384896,11.8483552 8.7284746,10.1411394 8.7284746,8.03299291 C8.7284746,6.02405919 10.4385566,4.31828125 12.5502423,4.31828125 Z" id="Fill-1" fill="#8D6018"/>
        </g>
      </svg>
    )
  }
}

export default MapMarker;